// The work stations — the phone drawer's (DrawerContent.STATIONS), same groups and order, so both apps read alike.
// HOME is pinned above them. A station with `to` is a straight link (no fold). `admin` = hidden from a member with
// grants (same rule as the phone). `foot` = not listed in the rail — Settings is the gear in its footer; it stays here
// so the top bar's crumb still names the page.
export const HOME = { to: '/', label: 'Home', icon: 'home', end: true };
// Pinned under Home: Notes — the thing the desk is used for most (Lj, 2026-09-29).
export const PINNED = [{ to: '/notes', label: 'Notes', icon: 'file-text' }];

export const STATIONS = [
  { key: 'plan', label: 'PLAN', icon: 'compass', items: [
    { to: '/plan', label: 'Plan', icon: 'list' },
    { to: '/week', label: 'Week', icon: 'target' },
    { to: '/calendar', label: 'Calendar', icon: 'calendar' },
    { to: '/forecast', label: 'Forecast', icon: 'cloud' },
    { to: '/reminders', label: 'Reminders', icon: 'bell' },
    { to: '/approvals', label: 'Approvals', icon: 'shield' },
    { to: '/settings/departments', label: 'Departments', icon: 'layers' },
    { to: '/settings/templates', label: 'Templates', icon: 'box' },
    { to: '/routines', label: 'Routines', icon: 'repeat' },
  ] },
  { key: 'team', label: 'TEAM', icon: 'users', to: '/team', admin: true, items: [
    { to: '/team', label: 'Team', icon: 'users' },
  ] },
  { key: 'execute', label: 'EXECUTE', icon: 'tool', items: [
    { to: '/projects', label: 'Projects', icon: 'folder' },
    { to: '/photos', label: 'Photos', icon: 'image' },
  ] },
  { key: 'time', label: 'TIME', icon: 'clock', items: [
    { to: '/time', label: 'Time sheets', icon: 'clock', end: true },
    { to: '/time/sessions', label: 'Time editor', icon: 'edit-3' },
  ] },
  { key: 'reflect', label: 'REFLECT', icon: 'eye', items: [
    { to: '/log', label: 'Daily log', icon: 'book-open' },
    { to: '/trips', label: 'Trips', icon: 'navigation' },
    { to: '/insights', label: 'Insights', icon: 'bar-chart-2' },
    { to: '/track', label: 'Track', icon: 'activity' },
    { to: '/cfo', label: 'CFO', icon: 'briefcase', admin: true },
  ] },
  { key: 'setup', label: 'SETUP', icon: 'settings', foot: true, items: [
    { to: '/settings', label: 'Settings', icon: 'settings', end: true },
  ] },
];

/** The station a path belongs to (longest matching item wins), for opening the right fold. */
export function stationFor(pathname) {
  let best = null; let len = -1;
  for (const st of STATIONS) {
    for (const it of st.items) {
      const hit = it.end ? pathname === it.to : pathname === it.to || pathname.startsWith(`${it.to}/`);
      if (hit && it.to.length > len) { best = st; len = it.to.length; }
    }
  }
  if (!best && pathname.startsWith('/insights')) best = STATIONS.find((s) => s.key === 'reflect');   // incl. the Screen time tab
  return best;
}
